const orderPage = [
  {
    path: "/orderLogging",
    name: "工单操作log",
    component: () =>
      import(
        /* webpackChunkName: "orderPage" */ "../views/order/orderLogging/logging.vue"
      ),
    meta: { id: "", hidden: true, name: "Operation log" }
  },
  // {
  //   path: "/ticket/applicationReview",
  //   name: "减免审核",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "orderPage" */ "../views/order/applicationReview/applicationReview.vue"
  //     ),
  //   meta: { id: 224, hidden: true, name: "menu.Applyapprove" }
  // },
  {
    path: "/reduceApproval",
    name: "减免审核",
    component: () =>
      import(
        /* webpackChunkName: "orderPage" */ "../views/order/reduceApproval/index.vue"
      ),
    meta: { id: 224, hidden: true, name: "menu.Applyapprove" }
  },
  {
    path: "/LawfirmList",
    name: "律所管理",
    component: () =>
      import(
        /* webpackChunkName: "approveManagement" */ "../views/order/lawyerFirmList/index.vue"
      ),
    meta: { id: 469, hidden: true, name: "menuLxy.lawyerFirmList" },

  },
];
export default orderPage;